import type { StatsConfig } from '@/components/composite/MediaViewer/components/MediaViewerStats/types';

import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { totalRepliesReceivedConfig } from '../totalRepliesReceived';

export const mediaViewerRepliesReceivedConfig: StatsConfig = {
    ...totalRepliesReceivedConfig,
    id: 'reply_count', // Override to match API field name
    type: 'kpi',
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
